import React, { useCallback, useEffect, useState } from "react";
import api, { formatApiError, formatTanggal } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_ORTU } from "@/lib/nav";
import { toast } from "sonner";
import { ClipboardCheck, CheckCircle2, AlertTriangle, Info } from "lucide-react";

export default function OrtuDaftarUlang() {
  const [data, setData] = useState(null);
  const [confirming, setConfirming] = useState(false);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/daftar-ulang/saya"); setData(data); }
    catch (e) { console.error(e); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const konfirmasi = async () => {
    if (!window.confirm("Konfirmasi daftar ulang anak Anda untuk tahun ajaran baru?")) return;
    setConfirming(true);
    try {
      await api.post("/daftar-ulang/saya/konfirmasi");
      toast.success("Daftar ulang berhasil dikonfirmasi");
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setConfirming(false); }
  };

  return (
    <Layout nav={NAV_ORTU}>
      <PageTitle title="Daftar Ulang" subtitle={data ? `Tahun Ajaran Baru ${data.tahun_ajaran}` : ""} />
      {!data ? (
        <div className="pp-card p-10 text-center text-slate-400">Memuat…</div>
      ) : (
        <section className="pp-card p-6 max-w-2xl" data-testid="ortu-du-card">
          {data.confirmed_at ? (
            <div className="text-center py-6">
              <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto mb-3" />
              <h3 className="text-xl font-bold text-slate-900 mb-1">Daftar Ulang Terkonfirmasi</h3>
              <p className="text-slate-600 text-sm">
                Anak Anda telah terdaftar ulang untuk Tahun Ajaran {data.tahun_ajaran} pada{" "}
                <b>{formatTanggal(data.confirmed_at)}</b>.
              </p>
            </div>
          ) : data.dibuka ? (
            <div className="text-center py-6">
              <ClipboardCheck className="w-14 h-14 text-indigo-500 mx-auto mb-3" />
              <h3 className="text-xl font-bold text-slate-900 mb-1">Daftar Ulang Dibuka</h3>
              <p className="text-slate-600 text-sm mb-5">
                Silakan konfirmasi daftar ulang anak Anda untuk Tahun Ajaran {data.tahun_ajaran}.
              </p>
              {data.catatan && (
                <div className="rounded-xl bg-amber-50 border border-amber-200 text-amber-800 text-sm p-3 mb-5 text-left" data-testid="ortu-du-catatan">
                  <b>Catatan dari sekolah:</b> {data.catatan}
                </div>
              )}
              <button onClick={konfirmasi} disabled={confirming} className="pp-btn-primary px-8 py-3 text-base" data-testid="ortu-du-konfirmasi">
                {confirming ? "Memproses…" : "Konfirmasi Daftar Ulang"}
              </button>
            </div>
          ) : data.catatan ? (
            <div className="text-center py-6">
              <AlertTriangle className="w-14 h-14 text-amber-500 mx-auto mb-3" />
              <h3 className="text-xl font-bold text-slate-900 mb-1">Daftar Ulang Belum Dapat Dilakukan</h3>
              <div className="rounded-xl bg-amber-50 border border-amber-200 text-amber-800 text-sm p-4 my-4 text-left" data-testid="ortu-du-catatan">
                <b>Catatan dari sekolah:</b>
                <div className="whitespace-pre-wrap mt-1">{data.catatan}</div>
              </div>
              <button disabled className="pp-btn-secondary px-8 py-3 text-base opacity-60 cursor-not-allowed" data-testid="ortu-du-disabled">
                Konfirmasi Daftar Ulang
              </button>
            </div>
          ) : (
            <div className="text-center py-6">
              <Info className="w-14 h-14 text-slate-300 mx-auto mb-3" />
              <p className="text-slate-500 text-sm">Menu daftar ulang belum dibuka oleh Admin.</p>
            </div>
          )}
        </section>
      )}
    </Layout>
  );
}
